import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      personal: {
        list_personal: {
          header: 'HEADER',
          add_admin: 'ADD',
          modal_window: {
            remove: {
              title: 'TITLE_REMOVE',
              message: 'MESSAGE_REMOVE',
              answer_yes: 'YES_REMOVE',
              answer_no: 'NO_REMOVE',
            },
            status: {
              title_banned: 'TITLE_BANNED',
              title_unbanned: 'TITLE_UNBANNED',
              message_banned: 'MESSAGE_BANNED',
              message_unbanned: 'MESSAGE_UNBANNED',
              answer_yes: 'YES_BANNED',
              answer_no: 'NO_BANNED',
            },
          },
        },
      },
    },
  }));
}
